var _ellipse, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinBlockedActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 45,
    viewBox: "0 0 29 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 41.6406,
    rx: 10.6333,
    ry: 2.5625,
    fill: "url(#paint0_radial_1304_281646)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.35C29 6.355 22.5786 0 14.5 0C6.42143 0 0 6.355 0 14.35C0 25.01 14.5 41 14.5 41C14.5 41 29 25.01 29 14.35Z",
    fill: "#F47721"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1C22.0361 1 28 6.91706 28 14.35C28 16.8094 27.1575 19.6564 25.8236 22.5983C24.496 25.5263 22.7169 28.4727 20.9231 31.1101C19.1313 33.7447 17.3375 36.0527 15.9909 37.7027C15.391 38.4378 14.8807 39.0412 14.5 39.4835C14.1193 39.0412 13.609 38.4378 13.0091 37.7027C11.6625 36.0527 9.86867 33.7447 8.07688 31.1101C6.28312 28.4727 4.50396 25.5263 3.17638 22.5983C1.84248 19.6564 1 16.8094 1 14.35C1 6.91706 6.96388 1 14.5 1Z",
    stroke: "#424E54",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1304_281646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1722 12.1719C18.7275 12.1719 18.3667 12.5306 18.3667 12.9727V16.6562H18.0444C16.9811 16.6562 16.1111 17.5211 16.1111 18.5781H15.4667C15.4667 17.2712 16.4527 16.195 17.7222 16.0348V9.12891C17.7222 8.68687 17.3613 8.32812 16.9167 8.32812C16.472 8.32812 16.1111 8.68687 16.1111 9.12891V14.0938H15.4667V7.84766C15.4667 7.40563 15.1058 7.04687 14.6611 7.04687C14.2164 7.04687 13.8555 7.40563 13.8555 7.84766V14.0938H13.2111V8.80859C13.2111 8.36656 12.8502 8.00781 12.4055 8.00781C11.9609 8.00781 11.6 8.36656 11.6 8.80859V14.7344H10.9555V10.7305C10.9555 10.2884 10.5947 9.92969 10.15 9.92969C9.70533 9.92969 9.34444 10.2884 9.34444 10.7305L9.34444 17.1367C9.34444 20.058 11.7224 22.4219 14.6611 22.4219C17.5998 22.4219 19.9778 20.058 19.9778 17.1367V12.9727C19.9778 12.5306 19.6169 12.1719 19.1722 12.1719Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1304_281646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5 41.6406) rotate(90) scale(2.5625 10.6333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424E54",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424E54",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1304_281646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4667,
    height: 15.375,
    fill: "white",
    transform: "translate(6.44444 7.04688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinBlockedActive);
export default __webpack_public_path__ + "static/media/Pin_Blocked_Active.4f347340041a2e7e7dbe278c9e2505b8.svg";
export { ForwardRef as ReactComponent };